export default __webpack_public_path__ + "static/media/greenspacedestactive2.ff942b5b.png";